"use client"

import { useState } from "react"
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { Block, CheckCircleOutline, Delete, MoreVert } from "@mui/icons-material"

const UserRowActions = ({ user, onToggleActive, onDelete }) => {
  const [anchor, setAnchor] = useState(null)
  const isInactive = user.isActive === false

  // Menu events bubble through the portal to the table row, whose click opens the user
  const run = (event, action) => {
    event.stopPropagation()
    setAnchor(null)
    action(user)
  }

  return (
    <>
      <IconButton
        size="small"
        aria-label={`Actions for ${user.firstName} ${user.lastName}`}
        onClick={(event) => {
          event.stopPropagation()
          setAnchor(event.currentTarget)
        }}
      >
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        onClick={(event) => event.stopPropagation()}
      >
        <MenuItem onClick={(event) => run(event, onToggleActive)}>
          <ListItemIcon>{isInactive ? <CheckCircleOutline fontSize="small" /> : <Block fontSize="small" />}</ListItemIcon>
          <ListItemText>{isInactive ? "Activate" : "Deactivate"}</ListItemText>
        </MenuItem>
        <MenuItem onClick={(event) => run(event, onDelete)} sx={{ color: "error.main" }}>
          <ListItemIcon sx={{ color: "inherit" }}>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}

export default UserRowActions
